import PropTypes from 'prop-types';
import React from 'react';
import Leaflet from 'leaflet';

import Station from '../../../records/Station';
import useMarker from '../../openMap/useMarker';
import config from '../../../config';

const StationMarker = ({station, onSelect}) => {
    const marker = new Leaflet.Marker(station.getLatLng(), {
        icon: Leaflet.icon({
            iconUrl: `/images/add-station-${config.get('brand').split('-')[0]}.png`,
            iconSize: [64, 80],
            iconAnchor: [26.5, 78],
        })
    }).on('mouseup', () => onSelect(station));

    useMarker(marker);
    return undefined;
};

StationMarker.propTypes = {
    station: PropTypes.instanceOf(Station).isRequired,
    onSelect: PropTypes.func.isRequired
};

export default React.memo(StationMarker);



// WEBPACK FOOTER //
// ./src/components/stationFinder/OpenStreetMaps/StationMarker.js